import { render, staticRenderFns } from "./ParcellesModificationsList.vue?vue&type=template&id=a136153a&scoped=true"
import script from "./ParcellesModificationsList.vue?vue&type=script&lang=js"
export * from "./ParcellesModificationsList.vue?vue&type=script&lang=js"
import style0 from "./ParcellesModificationsList.vue?vue&type=style&index=0&id=a136153a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a136153a",
  null
  
)

export default component.exports